import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import IncreaseRes from "../../../assets/ImageEditing/images/api-increase-resolution.jpg";
import Colorise from "../../../assets/ImageEditing/images/colorise.jpg";
import Restore from "../../../assets/ImageEditing/images/Restore_Old.jpg";

import EnhanceImages from "../../../assets/ImageEditing/images/enhance-images.png";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";

const RestorationEnhancement = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing.api" });
	const navigate = useNavigate();

	const rightActions = (
		<>
			<BriaButton buttonType="secondarySmall" onClick={() => navigate(RouterConstants.ACCOUNT_IFRAMES.fullPath)}>
				{t("headerButtons.configureIframe")}
			</BriaButton>
			<BriaButton
				buttonType="secondarySmall"
				onClick={() => navigate(RouterConstants.IMAGE_EDITING.IMAGE.DEMO.fullPath)}
			>
				{t("headerButtons.playground")}
			</BriaButton>
		</>
	);

	const openDocs = (link: string) => window.open(link, "_blank");

	const restorationEnhancementCards: ConsoleAPICardProps[] = [
		{
			image: EnhanceImages,
			header: t("cards.enhanceImage.header"),
			description: t("cards.enhanceImage.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.BRIA_NEW_PLATFORM_ENHANCE_IMAGE_SANDBOX, "_blank")}
					>
						{t("cards.enhanceImage.tryInSandboxBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_EDITING.ENHANCE_IMAGE.DOCS)}
					>
						{t("cards.enhanceImage.primaryBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.ENHANCE_IMAGE.DOCS),
		},
		{
			image: IncreaseRes,
			header: t("cards.increaseRes.header"),
			description: t("cards.increaseRes.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.BRIA_NEW_PLATFORM_INCREASE_RESOLUTION_SANDBOX, "_blank")
						}
					>
						{t("cards.increaseRes.tryInSandboxBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_EDITING.INCREASE_RESOLUTION.DOCS)}
					>
						{t("cards.increaseRes.primaryBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.INCREASE_RESOLUTION.DOCS),
		},
		{
			image: Restore,
			header: t("cards.restore.header"),
			description: t("cards.restore.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.RESTORE.DOCS)}>
					{t("cards.restore.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.RESTORE.DOCS),
		},
		{
			image: Colorise,
			header: t("cards.colorize.header"),
			description: t("cards.colorize.description"),
			buttons: (
				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_EDITING.COLORIZE.DOCS)}>
					{t("cards.colorize.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_EDITING.COLORIZE.DOCS),
		},
	];

	return (
		<ConsoleAPILayout rightActions={rightActions} showIntegrationKeyButton>
			<ConsoleAPICards cards={restorationEnhancementCards} />
		</ConsoleAPILayout>
	);
};

export default observer(RestorationEnhancement);
